import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { CurrentScorecardActions } from '../scorecard/current-scorecard-actions';
import { Action, Store } from '@ngrx/store';
// import {PlainScorecard} from '../../data/scorecard';
import { PlayerHomeActions } from './player-home-actions';
import { createAction } from '../create-action';
import { AppState } from '../appstate';
import { SessionActions } from '../session/session-actions';

import { PlainScoreCard } from '../../data/mygolf.data';

import { concatLatestFrom, createEffect } from 'node_modules/@ngrx/effects';
import { mergeMap, map, tap, filter } from 'rxjs/operators';
/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class PlayerHomeEffects {

    constructor(private actions$: Actions,
        private store: Store<AppState>,
        private playerHomeActions: PlayerHomeActions) {
            // alert("PlayerHomeEffects")
         }

    // @Effect({dispatch: false})
    // currentScorecard$ = this.actions$.pipe(ofType(CurrentScorecardActions.NORMAL_GAME_SCORECARD)).pipe
    //     (map((action: any)=>action.payload)).subscribe(
    //         (scorecard: PlainScoreCard)=>{
    //             this.playerHomeActions.checkScorecard(scorecard);
    //         });        


    currentScorecard$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrentScorecardActions.NORMAL_GAME_SCORECARD),
            map((action: any) => action.payload),
            tap((scorecard: PlainScoreCard) => this.playerHomeActions.checkScorecard(scorecard))
        ),
        {
            dispatch: false,
        }
    );


    // @Effect({dispatch: false})
    // onClearCurrentScorecard$ = this.actions$.pipe(ofType(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD)).subscribe(
    //     ()=>{
    //         this.playerHomeActions.refreshForcefully();
    //     })


    deviceRegistered$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD), tap((action: Action) => {
                // alert("PlayerHomeEffect_deviceRegistered")
               

                this.playerHomeActions.refreshForcefully();
            })
        ), { dispatch: false });



    // @Effect({dispatch: false})
    // noCurrentScorecard$ = this.actions$.pipe(ofType(CurrentScorecardActions.NO_CURRENT_SCORECARD,
    //     CurrentScorecardActions.CLEAR_CURRENT_SCORECARD, CurrentScorecardActions.FETCHED_CURRENT_SCORECARD))
    //     .subscribe(()=>{
    //         this.store.dispatch(createAction(PlayerHomeActions.SET_SELECTED_COMPETITION));
    //         this.store.dispatch(createAction(PlayerHomeActions.SELECT_COMPETITION_FOR_SCORING));
    //         this.store.dispatch(createAction(PlayerHomeActions.RESET_STATE));
    //     });



    noCurrentScorecard$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrentScorecardActions.NO_CURRENT_SCORECARD,
                CurrentScorecardActions.CLEAR_CURRENT_SCORECARD, CurrentScorecardActions.FETCHED_CURRENT_SCORECARD),
            tap(() => {

                // alert("PlayerHomeEffect_noCurrentScorecard")
               
                this.store.dispatch(createAction(PlayerHomeActions.SET_SELECTED_COMPETITION));
                this.store.dispatch(createAction(PlayerHomeActions.SELECT_COMPETITION_FOR_SCORING));
                this.store.dispatch(createAction(PlayerHomeActions.RESET_STATE));
            })
        ),
        {
            dispatch: false,
        }
    );


    // @Effect()
    // loginFormShow$ = this.actions$.ofType(SessionActions.SHOW_LOGIN)
    //     .map(()=>{
    //         return createAction(PlayerHomeActions.RESET_STATE);
    //     })


    loginFormShow$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.SHOW_LOGIN),
            map(() => {
                return createAction(PlayerHomeActions.RESET_STATE);
            })
        )
    );



}